<template>
  <div>
    <el-dialog :title="Dotitle" :visible.sync="outerVisible" width="70%" :before-close="handleClose">
      <el-form :model="form" :rules="rules" class="form_box">
        <el-form-item label="本地视频" prop="video">
          <!-- <el-input v-model="form.video" autocomplete="off"></el-input> -->
          <el-upload :disabled="disabled" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :http-request="successuploadhandle">
            <div v-if="form.video" class="shiping">
              <img src="../../../../assets/img/img_shiping.png" class="shiping_Img" alt="" />
              <i v-if="!disabled" class="el-icon-error shipingDelet" @click.stop="Delete('video')"></i>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div v-if="identify_msg == ''" class="avatar_uploader">格式要求: 视频限制5-600秒,支持mp4、mov、m4v、flv、x-flv、mkv、wmv、avi、rmvb、3pg格式</div>
          <div v-else class="avatar_uploader" style="color:#F56C6C">{{ identify_msg }}</div>
        </el-form-item>
        <el-form-item label="所选分组">
          <el-select v-model="form.class" :disabled="disabled" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联商品">
          <!-- <el-input v-model="form.shop" autocomplete="off"></el-input> -->
          <span v-if="form.shop">
            <el-tag v-for="tag in form.shop" :key="tag.id" :closable="!disabled" :disable-transitions="false" @close="handleTagClose(tag)" style="margin-right:5px">{{ tag.name }}</el-tag>
          </span>
          <el-link type="primary" :disabled="disabled" :underline="false" @click="SelectAssociatedProduct">选择关联商品</el-link>
        </el-form-item>
        <el-form-item label="关联位置" prop="Address">
          <el-radio :disabled="disabled" v-model="form.Address" label="1">轮播图</el-radio>
          <el-radio :disabled="disabled" v-model="form.Address" label="2">详情页</el-radio>
        </el-form-item>
        <el-form-item label="视频封面">
          <el-upload :disabled="disabled" class="uploader" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false" :http-request="successupImg">
            <div v-if="form.img" class="shiping">
              <img :src="form.img" class="shiping_Img" alt="" />
              <i v-if="!disabled" class="el-icon-error shipingDelet" @click.stop="Delete('img')"></i>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div v-if="identify_msg == ''" class="avatar_uploader">建议尺寸: 800X800,支持jpg、gif、png、bmp格式,大小不超过10Mb</div>
          <div v-else class="avatar_uploader" style="color:#F56C6C">{{ identify_msg }}</div>
          <div v-if="!disabled" class="avatar_uploader"><el-checkbox v-model="form.agree">阅读并同意</el-checkbox> <el-link type="primary" :underline="false">《视频上传服务协议》</el-link></div>
        </el-form-item>
      </el-form>
      <!-- 二层弹框 -->
      <el-dialog width="70%" title="批量关联商品" :visible.sync="innerVisible" append-to-body :before-close="handleTwoClose">
        <div>
          <div class="dflex jusc">
            <span class="dflex">
              <span>商品名称：</span>
              <el-input v-model="Shopop.ShopName" style="width: 240px" placeholder="请输入名称" clearable></el-input>
            </span>
            <!-- <span class="dflex"> 
              <span>商品分类：</span>
              <el-select v-model="Shopop.ShopoptionName" placeholder="请选择分类">
                <el-option
                  v-for="item in Shopoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> 
            </span> -->
            <span style="margin-left:30px">
              <el-button type="primary" @click="rufsh">搜索</el-button>
              <el-button type="primary" @click="init">重置</el-button>
            </span>
          </div>
          <div style="height:50px;line-height:50px;color:#FF0066">如果该商品线上已有视频，不允许关联该商品</div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <ul class="shopList_titel">
              <li v-for="item in shopList" :key="item.id" class="shopList_box">
                <el-checkbox :label="item.id" class="shopList_item" :disabled="item.disabled">
                  <img :src="item.image_main" alt="" style="width:81px;height:81px;border-radius: 5px;" />
                  <div class="ContentNameShop">
                    <div style="margin-top:10px;font-size:13px">
                      <div>{{ item.name }}</div>
                      <div>
                        <span>商品ID :{{ item.id }}</span>
                      </div>
                    </div>

                    <div style="font-size:18px"><span style="font-size:13px">￥</span> {{ item.price }}</div>
                  </div>
                </el-checkbox>
              </li>
            </ul>
          </el-checkbox-group>
          <div class="TwoBott">
            <div>
              <el-button type="info" plain @click="handleCheckAllChange">全选本页</el-button>
              <el-button type="info" plain @click="handleCheckNoAllChange">取消本页已选</el-button>
            </div>
            <div class="page">
              <el-pagination
                @size-change="sizeChange"
                @current-change="handleSizeChange"
                background
                :current-page="TowPait.page"
                :page-sizes="[12, 24, 36, 48]"
                :page-size="TowPait.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="TowPait.total"
              >
              </el-pagination>
            </div>
          </div>
          <div slot="footer" class="Batch_btn">
            <el-button type="primary" @click="BingShop">批量绑定商品</el-button>
          </div>
        </div>
      </el-dialog>
      <div v-if="!disabled" slot="footer" class="dialog-footer">
        <el-button @click="Nosave">取 消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import help from "@/assets/js/common.js";
import { mapActions, mapGetters } from "vuex";
import TcVod from "vod-js-sdk-v6";
export default {
  props: {
    openUndata: {
      type: Boolean
    }
  },
  data() {
    return {
      Dotitle: "上传视频",
      disabled: false, //是否处于详情禁用状态
      outerVisible: false, //外层的弹出框
      innerVisible: false, //第二层的弹出框
      // img:"../../../../assets/img/img_shiping.png",
      options: [], //分组所需数组
      rules: {
        //必填项
        video: [{ required: true, message: "请选择上传的视频", trigger: "blur" }],
        Address: [{ required: true, message: "请选择关联位置", trigger: "change" }]
      },
      Shopoptions: [], //批量商品的搜索条件的分类
      Shopop: {
        ShopoptionName: "", //批量商品分类选中
        ShopName: "" //批量商品名称
      },
      shopList: [], //批量数组
      TowPait: {
        page: 1,
        limit: 12,
        total: 0
      },
      checkedCities: [], //选中之后的数组
      topcheckedCities: [], //选中之后的数组的Item
      form: {
        //外层所需
        video: "", //视频名字
        size: "", //视频大小
        class: 0, //分组
        shop: [], //商品
        Address: "", //位置
        img: "", //封面
        agree: false, //是否阅读同意
        upload_time: "" //视频上传之后的时间
      },
      FileID: "", //视频上传之后的文件ID
      videoURL: "", //视频上传之后的播放地址
      Editbool: 0, //是否是编辑状态
      identify_msg: "" //鉴黄失败的原因
    };
  },
  created() {
    let arr = "[1,2]";
    console.log("object :>> ", JSON.parse(arr));
  },
  mounted() {
    this.GetGroupList();
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions({
      GetAutograph: "Content/GetAutograph", //获取上传视频的签名
      Addification: "Content/Addification", //视频鉴黄接口
      Editification: "Content/Editification", //视频鉴黄接口
      DetailContentItem: "Content/DetailContentItem", //素材中心详情接口
      GroupList: "Content/GroupList", //获取分组接口
      uploadFile: "commodity/uploadFile",
      shopListAct: "Content/shopListAct"
    }),
    GetGroupList() {
      //获取分组
      let data = {
        token: this.getToken
      };
      this.GroupList(data).then(res => {
        if (res.code === 1) {
          this.options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Edit(item) {
      //编辑操作
      let data = {
        token: this.getToken,
        id: item.id
      };
      this.DetailContentItem(data).then(res => {
        if (res.code === 1) {
          this.videoURL = res.data.url;
          this.form.img = res.data.image_url;
          this.form.class = res.data.local_video_group_id;
          this.form.shop = res.data.goods_info;
          this.checkedCities = res.data.goods_info.map(item => {
            return item.id;
          });
          this.form.Address = res.data.location.toString();
          this.form.video = res.data.title;
          this.FileID = res.data.file_code;
          this.form.size = res.data.size;
          this.form.upload_time = res.data.upload_time;
          this.videoURL = res.data.url;
          this.form.agree = true;
          this.Editbool = item.id;
          this.disabled = false;
          if (res.data.identify_status == 3) {
            console.log("object :>> ", res.data.identify_msg);
            this.identify_msg = res.data.identify_msg;
          }
        }
      });
    },
    details(item) {
      //详情操作
      let data = {
        token: this.getToken,
        id: item.id
      };
      this.DetailContentItem(data).then(res => {
        if (res.code === 1) {
          this.form.video = res.data.url;
          this.form.img = res.data.image_url;
          this.form.class = res.data.local_video_group_id;
          this.form.shop = res.data.goods_info;
          this.checkedCities = res.data.goods_info.map(item => {
            return item.id;
          });
          this.form.Address = res.data.location.toString();
          this.form.video = res.data.title;
          this.FileID = res.data.file_code;
          this.form.size = res.data.size;
          this.form.upload_time = res.data.upload_time;
          this.disabled = true;
        }
      });
    },
    sizeChange(val) {
      //二次弹框的每页条数
      this.TowPait.limit = val;
      this.ShopGetList();
    },
    handleSizeChange(val) {
      //二次弹框的每页
      this.TowPait.page = val;
      this.ShopGetList();
    },
    BingShop() {
      //二次弹框确定事件
      this.innerVisible = false;
      this.form.shop = this.topcheckedCities; // 选中的item
    },
    handleCheckAllChange() {
      this.shopList.forEach(item => {
        if (!item.disabled) {
          this.checkedCities.push(item.id);
          this.topcheckedCities.push(item);
        }
      });
      // console.log('checkedCount :>> ', value);
      // this.checkedCities
      // this.checkAll = checkedCount === this.shopList.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.shopList.length;
    },
    handleCheckNoAllChange() {
      this.checkedCities = [];
      this.shopList.forEach(item => {
        if (item.disabled) {
          this.checkedCities.push(item.id);
        }
      });
    },
    handleCheckedCitiesChange(val) {
      //二次弹框的单选事件
      // this.form.shop=val
      let arr = new Set(this.checkedCities);
      this.shopList.forEach(item => {
        arr.forEach(item2 => {
          if (item.id === item2 && !item.disabled) {
            this.topcheckedCities.push(item);
          }
        });
      });
      let obj = {};
      this.topcheckedCities = this.topcheckedCities.reduce((newArr, next) => {
        obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
        return newArr;
      }, []);
      console.log(" this.topcheckedCities :>> ", this.topcheckedCities);
      return this.topcheckedCities;
    },
    Delete(valuename) {
      //删除选中视频或者图片
      if (valuename == "video") {
        this.form.video = "";
      }
      if (valuename == "img") {
        this.form.img = "";
      }
    },
    rufsh() {
      //搜索事件
      this.ShopGetList();
    },
    init() {
      //重置事件
      this.Shopop = {};
      this.ShopGetList();
    },
    async SelectAssociatedProduct() {
      //关联商品点击事件
      this.innerVisible = true;
      await this.ShopGetList();
      console.log("this.shipList :>> ", this.shipList);
    },
    ShopGetList() {
      //获取文件上传时关联商品的数据
      let data = {
        size: this.TowPait.limit,
        page: this.TowPait.page,
        token: this.getToken,
        video_id: this.Editbool,
        name: this.Shopop.ShopName
      };
      this.shopListAct(data).then(res => {
        if (res.code == 1) {
          res.data.list.forEach(item => {
            item.disabled = false;
            res.data.used.forEach(item2 => {
              if (item.id === item2) {
                item.disabled = true;
              }
            });
          });
          this.shopList = res.data.list;
          this.checkedCities = [...this.checkedCities, ...res.data.used];
          this.shopList.forEach(item => {
            this.checkedCities.forEach(item2 => {
              if (item.id === item2 && !item.disabled) {
                this.topcheckedCities.push(item);
              }
            });
          });
          this.TowPait.total = res.data.count;
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    handleTagClose(tag) {
      this.form.shop.splice(this.form.shop.indexOf(tag), 1);
    },
    Nosave() {
      (this.form.video = ""), //视频
        (this.form.class = ""), //分组
        (this.form.shop = []), //商品
        (this.form.Address = ""), //位置
        (this.form.img = ""), //封面
        (this.form.agree = false), //是否阅读同意
        (this.checkedCities = []);
      this.topcheckedCities = [];
      this.outerVisible = false;
    },
    save() {
      //保存事件
      if (!this.form.agree) {
        this.$message.error("请仔细阅读并同意《视频上传服务协议》");
        return;
      }
      if (!this.form.video) {
        this.$message.error("请选择视频文件进行上传");
        return;
      }
      if (!this.form.img) {
        this.$message.error("请选择视频封面进行上传");
        return;
      }
      if (this.form.shop.length < 1) {
        this.$message.error("请选择关联的商品");
        return;
      }
      console.log(
        "this.form.shop.map(item =>{ return item.id}) :>> ",
        this.form.shop.map(item => {
          return item.id;
        })
      );
      let data = {
        token: this.getToken,
        title: this.form.video, //文件名
        file_code: this.FileID, //媒体文件的唯一标识,由上传视频成功后返回
        url: this.videoURL, //视频url,由上传成功后返回
        image_url: this.form.img, //封面图url,由上传成功后返回
        local_video_group_id: this.form.class, //视频分组id
        goods_id: this.form.shop.map(item => {
          return item.id;
        }), //关联商品id,至少一个
        location: parseInt(this.form.Address), //关联位置 1-轮播图，2-详情页
        size: this.form.size, //视频文件大小，单位MB，进一法
        upload_time: this.form.upload_time //上传时间,由上传成功后返回，时间戳
      };
      console.log("data :>> ", data);
      if (this.Editbool || this.Editbool > 0) {
        data.id = this.Editbool;
        this.Editification(data).then(res => {
          if (res.code === 1) {
            this.$message.success("修改成功！");
            this.outerVisible = false;
            this.Editbool = 0;
            this.$parent.GetListCon();
          } else {
            this.outerVisible = false;
            this.$message.error(res.msg);
          }
          (this.form.video = ""), //视频
            (this.form.class = ""), //分组
            (this.form.shop = []), //商品
            (this.form.Address = ""), //位置
            (this.form.img = ""), //封面
            (this.form.agree = false), //是否阅读同意
            (this.checkedCities = []);
        });
      } else {
        this.Addification(data).then(res => {
          if (res.code === 1) {
            this.$message.success("添加成功！");
            this.$parent.GetListCon();
            this.outerVisible = false;
            this.Editbool = 0;
          } else {
            this.outerVisible = false;
            this.$message.error(res.msg);
          }
          (this.form.video = ""), //视频
            (this.form.class = ""), //分组
            (this.form.shop = []), //商品
            (this.form.Address = ""), //位置
            (this.form.img = ""), //封面
            (this.form.agree = false), //是否阅读同意
            (this.checkedCities = []);
        });
      }
    },
    handleTwoClose(done) {
      //第二层关闭
      done();
      console.log("关闭第二次 :>> ");
    },
    handleClose(done) {
      //第一层关闭
      (this.form.video = ""), //视频
        (this.form.class = ""), //分组
        (this.form.shop = []), //商品
        (this.form.Address = ""), //位置
        (this.form.img = ""), //封面
        (this.form.agree = false), //是否阅读同意
        (this.checkedCities = []);
      this.topcheckedCities = [];
      done();
    },
    successupImg(content) {
      let filename = content.file.name.slice(content.file.name.lastIndexOf(".") + 1);
      if (filename.indexOf("jpg,gif,png,bmp") != -1) {
        return this.$message.error("请选择图片文件进行上传");
      }
      if (content.file.size / 1024 / 1024 >= 10) {
        this.$message({
          type: "warning",
          message: "当前图片大小超过限制"
        });
        return;
      }
      var formdata = new FormData();
      formdata.append("img", content.file);
      this.uploadFile(formdata).then(res => {
        if (res.code == 200) {
          this.$message.success("上传成功！");
          this.form.img = res.data;
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
      // var img = URL.createObjectURL(content.file); //imgurl 就是你的图片路径
      // var image = new Image();
      //     image.src = img;
      //     image.onload =()=> {
      //       var base64 = imgBane.getBase64Image(image); // blob 转 base64
      //       this.form.img= base64;  //此处可以成功转成 base64，但是无法赋值全局变量 this.certificate
      // }
    },
    getSignature(getSignatureName, file) {
      //上传到腾讯云
      const getSignature = async () => {
        return getSignatureName;
      };
      const tcVod = new TcVod({
        getSignature: getSignature // 前文中所述的获取上传签名的函数
      });
      const uploader = tcVod.upload({
        mediaFile: file // 媒体文件（视频或音频或图片），类型为 File
      });
      uploader.on("media_progress", info => {
        // 上传进度
        if (info.percent == 1) {
          const that = this;
          that.$message.success("视频长传成功");
        }
      });
      uploader
        .done()
        .then(doneResult => {
          const that = this;
          that.FileID = doneResult.fileId;
          that.videoURL = doneResult.video.url;
          that.form.upload_time = help.getRQ(new Date().getTime() / 1000);
        })
        .catch(function(err) {
          console.log("doneResult:>> ", err);
        });
    },
    async successuploadhandle(response) {
      //选择文件上传
      let filename = response.file.name.slice(response.file.name.lastIndexOf(".") + 1);
      console.log(filename.indexOf("mp4,mov,m4v,flv,x-flv,mkv,wmv,avi,rmvb,3pg"));
      if (filename.indexOf("mp4,mov,m4v,flv,x-flv,mkv,wmv,avi,rmvb,3pg") != -1) {
        return this.$message.error("请选择视频文件进行上传");
      }
      let FileName = response.file.name;
      this.form.video = FileName.slice(0, FileName.lastIndexOf("."));
      this.form.size = response.file.size;
      console.log("response :>> ", response.file.name.slice(0, response.file.name.lastIndexOf(".")));
      var fileurl = URL.createObjectURL(response.file); //经测试，发现audio也可获取视频的时长
      var audioElement = new Audio(fileurl);
      var durationtime;
      await audioElement.addEventListener("loadedmetadata", () => {
        durationtime = audioElement.duration;
        let data = {
          duration: durationtime,
          size: response.file.size
        };
        this.GetAutograph(data).then(res => {
          if (res.code === 1) {
            console.log("res :>> ", res);
            this.getSignature(res.data, response.file);
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
ul li {
  list-style: none;
}
.form_box {
  margin-left: 150px;
  .avatar_uploader {
    margin-left: 67px;
    color: #666666;
  }
}
.shiping {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  .shiping_Img {
    width: 120px;
    height: 120px;
  }
  .shipingDelet {
    position: absolute;
    top: -10px;
    right: -10px;
    color: red;
    background-color: #fff;
    border-radius: 50%;
    font-size: 16px;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.dflex {
  display: flex;
  align-items: center;
}
.jusc {
  justify-content: flex-start;
  margin-left: 30px;
}

.shopList_titel {
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &:nth-child(3n-1) {
    margin-right: 0px;
  }
  .shopList_box {
    width: 30%;
    margin-bottom: 20px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    .shopList_item {
      flex: 1;
      display: flex;
      align-items: center;
      .ContentNameShop {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}
.shopList_item ::v-deep .el-checkbox__label {
  display: flex;
}
.TwoBott {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Batch_btn {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
